<template>
<div>

    <v-list-group
            no-action
            sub-group
            app
            dark
            active-class="grey"
        >
   
        <template v-slot:activator>
            <v-list-item-content>
                <v-list-item-title>
             
                        <strong>{{subpages.label.toUpperCase()}}</strong>
                   
                </v-list-item-title>        
            </v-list-item-content>
        </template>
      
            <v-list-item
                    v-for="subpage in subpages.subpages"
                    :key="subpage.label"
                    :to="subpage.url"
                    link
                    active-class="white"
                >   
                        
                        <v-list-item-title
                            v-text="subpage.label.toUpperCase()"
                        ></v-list-item-title>
                  
            </v-list-item>
        </v-list-group>
    </div>

</template>

<script>
export default {
    name: "nestedList",
    props: {
        subpages: Object
    }

}
</script>

<style>
    .menu-box{
        width: 100px;
        height: 50px;
        border-style: hidden;
        
        text-align: center;
        
        font-style: normal;
        font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif; 
        font-weight: 800;
        color: rgb(109, 8, 16);
        font-size: 32px;
    
        margin-top: 6px;
        border-radius: 10px;
        background: whitesmoke;
        box-shadow: 0 3px 12px 0 rgba(143, 1, 43, 0.4), 0 1px 15px 0 rgba(138, 3, 3, 0.19);
    }

</style>